import { render, staticRenderFns } from "./AgendamentoMapTab.vue?vue&type=template&id=5d2c84e4&scoped=true&"
import script from "./AgendamentoMapTab.vue?vue&type=script&lang=js&"
export * from "./AgendamentoMapTab.vue?vue&type=script&lang=js&"
import style0 from "./AgendamentoMapTab.vue?vue&type=style&index=0&id=5d2c84e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2c84e4",
  null
  
)

export default component.exports